import { Grid, Typography } from "@mui/material";
import ControlledTextField from "components/Controller/ControlledTextField";
import { CustomizedBox } from "components/Custom/CustomizedBox";
import { useDisable } from "hooks/use-disable";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IDeliveryTrip } from "types/Logistic/deliveryTrip";

const DeliveryRemark = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IDeliveryTrip>();
  const { t } = useTranslation();

  const [disabled] = useDisable();

  return (
    <CustomizedBox margin={"1rem 0rem 0rem 0rem"}>
      <Typography fontWeight={600} mb={2}>
        {t("sentence.remark")}
      </Typography>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={12}>
          <ControlledTextField
            placeholder={t("sentence.remark")}
            name="remark"
            control={control}
            error={Boolean(errors.remark)}
            helperText={errors.remark?.message?.toString()}
            multiline
            rows={4}
            viewMode={disabled}
          />
        </Grid>
      </Grid>
    </CustomizedBox>
  );
};

export default DeliveryRemark;
